import { sharedExtensionCards } from "backend/src/common/gameData/extensions.shared";
import { ExtensionType } from "backend/src/common/types/ExtensionCard";
import { AnimalCardModelType } from "store/models/AnimalCard";
import { getAnimalContext } from "./context/getAnimalContext";
import { formatMessage, Locale } from "backend/src/common/i18n";

export const getAnimalMeta = (
  card: AnimalCardModelType,
  locale: Locale,
): string => {
  const eggExtension = card.extensions.find(
    (extension) => extension.type === ExtensionType.egg,
  );
  const meta = [
    formatMessage(locale, "animal.meta.age", { count: card.age }),
    card.isBlocked &&
      card.extensions.some(
        (extension) => extension.type === ExtensionType.predator,
      ) &&
      formatMessage(locale, "animal.meta.cantAttack"),
    card.isPoisoned && formatMessage(locale, "animal.meta.poisoned"),
    card.isHidden && formatMessage(locale, "animal.meta.hidden"),
    card.cantEat && formatMessage(locale, "animal.meta.cantEat"),
    card.patronsCount > 0 && formatMessage(locale, "animal.meta.protected"),
    card.isFull && formatMessage(locale, "animal.meta.full"),
    card.extensions.some(
      (extension) => extension.type === ExtensionType.burrowing,
    ) &&
      sharedExtensionCards[ExtensionType.burrowing].getAdditionalMeta?.(
        getAnimalContext(card),
      ) &&
      formatMessage(locale, "animal.meta.inBurrow"),
    card.extensions.some((extension) => extension.type === ExtensionType.fly) &&
      formatMessage(locale, "animal.meta.kg", {
        count: card.extensions.length,
      }),
    eggExtension?.data?.stepsToBeBorn &&
      formatMessage(locale, "animal.meta.hatchesIn", {
        count: eggExtension.data.stepsToBeBorn,
      }),
  ]
    .filter(Boolean)
    .join(", ");
  return meta;
};
